class FreeProducts {
  constructor() {
    this.leftDiscount = 0;
    const events = ["DOMContentLoaded", "itemQuantityUpdated", "addToCart", "chocoCartUpdated"];
    events.forEach((eventName) => {
      document.addEventListener(eventName, async (event) => {
        switch (eventName) {
          case "addToCart":
          case "DOMContentLoaded":
            console.log("case addToCart");
            await this.updateFreeProductsSections('addToCart event');
            break;

          case "itemQuantityUpdated":
            console.log("case itemQuantityUpdated");
            let parcedDetail = JSON.parse(event.detail);
            let quantity;
            if(parcedDetail) {
              quantity = parcedDetail.quantity;
            }

            if(!parcedDetail || !Number(quantity)) {
              await this.collectProductsToRemove('itemQuantityUpdated event');
            }
            await this.updateFreeProductsSections('itemQuantityUpdated event');
            break;
          case "chocoCartUpdated":
            console.log("case chocoCartUpdated");
            await FreeProducts.updateCartSections();
            break;
          default:
            break;
        }
        });
      });

  }

  async getDiscountedProducts(cartData) {
    const itemsToUpdate = this.getItemsToUpdate(cartData);

    if (!itemsToUpdate) return;
    const itemGroups = this.groupItemsByHandle(itemsToUpdate);

    let highestCostItem; // Declare the variable outside the loop

    // Iterate through each item group
    itemGroups.forEach((itemGroup) => {
      const highestCostItem = this.getHighestCostItem(itemGroup.items); // Assign the value here
      const lowestCostItems = this.getLowestCostItems(itemGroup.items);

      const highestCostItemProperties = highestCostItem.properties || {};

      const highestCostItemDiscount = Number(this.calculateDiscount(highestCostItem, cartData));
      highestCostItemProperties._discount = highestCostItemDiscount.toString();
      this.leftDiscount = Number(this.getHighestGroupDiscount(itemGroup, cartData) - highestCostItemDiscount);

      function getItemQuantity(item) {
        return cartData.items.find((cartItem) => cartItem.key === item.key).quantity;
      }
      
      // Update the highest cost item with the discount value
      const updatedHighestCostItem = {
        "id": highestCostItem.key,
        "properties": highestCostItemProperties,
        "quantity": getItemQuantity(highestCostItem)
      };

      const updatedLowestCostItems = lowestCostItems.map((item) => {
        const itemProperties = item.properties || {};
        itemProperties._discount = this.leftDiscount > 0 ? this.calculateDiscount(item, cartData, true) : "";
        return {
          "id": item.key,
          "properties": itemProperties,
          "quantity": getItemQuantity(item)
        };
      });

      // Prepare the updates object for the POST request
      const updates = [
        updatedHighestCostItem,
        ...updatedLowestCostItems
      ];

      // Iterate through each item in updates and make a POST request to update the item in the cart
      const updateCartItems = async (index) => {
        if (index >= updates.length) {
          // Reached the end of the array
          const matchingCartItems = [];
          itemGroups.forEach((itemGroup) => {
            const highestCostItem = this.getHighestCostItem(itemGroup.items);
            const matchingCartItem = cartData.items.find((cartItem) => cartItem.key === highestCostItem.key);

            if (matchingCartItem) {
              const discount = this.calculateDiscount(highestCostItem, cartData);

              if (matchingCartItem.properties._discount === discount) {
                matchingCartItems.push(matchingCartItem);
              }
            }
          });

          if (matchingCartItems.length === itemGroups.length) {
            return false; // Return when all properties with discounts are matched
          }

          // return this.updateFreeProductsSections('getDiscountedProducts');
          return true;
        }
      
        const item = updates[index];
        try {
          await fetch(`/cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(item)
          })
          updateCartItems(index + 1);
        } catch (error) {
          console.error('Error:', error);
        }
      };
      
      // Start updating cart items from index 0
      updateCartItems(0);
      
      
    });

  }

  async handleMixAndMatch(cartData, mixAndMatch) {
    let discountCode = mixAndMatch.discountCode;
    let totalFreeQualified = mixAndMatch.totalFreeQualified;
  
    let discountedItems = cartData.items.filter(
      (cartItem) => cartItem.properties?._discount_campaign === discountCode
    );
    let discountedItemsQuantity = discountedItems.reduce((total, item) => total + item.quantity, 0);
  
    console.log("discountedItemsQuantity", discountedItemsQuantity);
  
    if (totalFreeQualified === discountedItemsQuantity) {
      console.log("All items are already discounted.");
      return;
    }
  
    const updates = [];
    const changes = [];
    const additions = [];
  
    if (totalFreeQualified === 0) {
      if (discountedItemsQuantity === 0) {
        console.log("No discounted items to process.");
        return;
      } else {
        discountedItems.forEach((item) => {
          let properties = { ...item.properties };
          delete properties._discount_campaign;
          changes.push(addUpdatedItem(item.key, properties, item.quantity, "change"));
        });
      }
    } else {
      const disqualifiedItems = mixAndMatch.disqualifiedProducts || [];
  
      const sortedItems = cartData.items
        .filter(
          (cartItem) =>
            (cartItem.final_line_price > 0 ||
              cartItem.properties?._discount_campaign === discountCode) &&
            !disqualifiedItems.includes(cartItem.product_id)
        )
        .sort((a, b) => a.final_price - b.final_price);
  
      for (let item of sortedItems) {
        const isFree = item.properties?._discount_campaign === discountCode;
        const quantity = item.quantity;
  
        if (totalFreeQualified === 0) {
          if (isFree) {
            let properties = { ...item.properties };
            delete properties._discount_campaign;
            changes.push(addUpdatedItem(item.key, properties, quantity, "change"));
          }
          continue;
        }
  
        if (totalFreeQualified === quantity) {
          if (!isFree) {
            let properties = { ...item.properties, _discount_campaign: discountCode };
            changes.push(addUpdatedItem(item.key, properties, quantity, "change"));
          }
          totalFreeQualified = 0;
        } else if (totalFreeQualified < quantity) {
          if (isFree) {
            let remainingQuantity = quantity - totalFreeQualified;
            updates.push(addUpdatedItem(item.key, null, totalFreeQualified, "update"));
            updateSameItem(item.id, item.key, remainingQuantity);
          } else {
            let properties = { ...item.properties, _discount_campaign: discountCode };
            changes.push(addUpdatedItem(item.key, properties, totalFreeQualified, "change"));
            updateSameItem(item.id, item.key, quantity - totalFreeQualified);
          }
          totalFreeQualified = 0;
        } else {
          if (!isFree) {
            let properties = { ...item.properties, _discount_campaign: discountCode };
            changes.push(addUpdatedItem(item.key, properties, quantity, "change"));
          }
          totalFreeQualified -= quantity;
        }
  
        if (totalFreeQualified <= 0) break;
      }
    }
  
    if (updates.length || additions.length || changes.length) {
      await this.processUpdates(updates, additions, changes);
    }
  
    function updateSameItem(id, key, quantity) {
      const findSameItem = cartData.items.find((cartItem) => cartItem.id === id && cartItem.key !== key);
  
      if (findSameItem && !findSameItem.properties?._discount_campaign === discountCode) {
        const properties = { ...findSameItem.properties };
        if (properties._discount_campaign === discountCode) {
          delete properties._discount_campaign;
        }
        updates.push(addUpdatedItem(findSameItem.key, properties, quantity, "update"));
      } else {
        additions.push(addUpdatedItem(id, null, quantity, "add"));
      }
    }
  
    function addUpdatedItem(id, properties, quantity, method) {
      if (method === "change") {
        return { id, quantity, ...(properties && { properties }) };
      } else if (method === "add") {
        return { items: [{ id, quantity, ...(properties && { properties }) }] };
      } else if (method === "update") {
        return { updates: { [id]: quantity } };
      }
    }
  }

  async processUpdates(updates, additions, changes) {
    if (changes.length > 0) {
      for (let i = 0; i < changes.length; i++) {
        console.log("Updating cart item:", changes[i]);
        try {
          await fetch(`/cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(changes[i]),
          });
        } catch (error) {
          console.error("Error updating cart:", error);
        }
      }
    }
  
    if (updates.length > 0) {
      await this.updateProducts(updates[0], "update");
    }
  
    if (additions.length > 0) {
      await this.addProducts(additions[0]);
    }
  }
  

  getHighestGroupDiscount(itemGroup) {
    const highestCostItemDiscount = this.getHighestCostItem(itemGroup.items).discount;
    return highestCostItemDiscount[Object.keys(highestCostItemDiscount)[Object.keys(highestCostItemDiscount).length - 1]];
  }
  
  getItemsToUpdate(cartData) {
    const stackedProductList = window.stackedProductList;
    const itemsToUpdate = [];
    
    for (const item of stackedProductList) {
      const matchingItem = cartData.items.find((cartItem) => cartItem.key === item.key);
      if (matchingItem) {
        itemsToUpdate.push(item);
      }
    }
    
    return itemsToUpdate;
  }    
  
  groupItemsByHandle(items) {
    const itemGroups = [];
    const groupedKeys = new Set();
  
    items.forEach((item) => {
      if (!groupedKeys.has(item.handle)) {
        const group = {
          handle: item.handle,
          items: items.filter((i) => i.handle === item.handle),
        };
        itemGroups.push(group);
        groupedKeys.add(item.handle);
      }
    });
  
    return itemGroups;
  }
  
  getHighestCostItem(items) {
    return items.reduce((highestCostItem, currentItem) => {
      return currentItem.original_line_price > highestCostItem.original_line_price ? currentItem : highestCostItem;
    }, items[0]);
  }
  
  getLowestCostItems(items) {
    const highestCostItem = this.getHighestCostItem(items);
    return items.filter((item) => item.original_line_price < highestCostItem.original_line_price);
  }
  
  calculateDiscount(item, cartData, isLowestCostItem) {
    const cartItem = cartData.items.find((cartItem) => cartItem.key === item.key);
    const pouchQty = item.title.includes('3 Pouch') ? 3 : item.title.includes('5 Pouch') ? 5 : 1;
    let quantity = cartItem.quantity;
    let totalQty = pouchQty * quantity;
  
    if (totalQty > 5) {
      totalQty = 5;
    }

    if(!isLowestCostItem) {
      return item.discount[totalQty];
    }

    if(this.leftDiscount >= item.discount[totalQty]) {
      this.leftDiscount = this.leftDiscount - item.discount[totalQty];
      return item.discount[totalQty];
    } else {
      let discount = this.leftDiscount.toString();
      this.leftDiscount = 0;
      return discount;
    }

  }

  isObjectEmpty = (objectName) => {
    return Object.keys(objectName).length === 0
  }
  
  async addProducts(items) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(items)
      })
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async updateProducts(updates, call) {
      try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
    } catch (error) {
      console.error('Error:', error);
    } finally {
      if (call === 'update') {
        window.cartUpdatesGlobal = {};
      }
      if (call === 'remove') {
        await FreeProducts.updateCartSections();
      }
    }

  }

  async collectProductsToRemove(cause) {
    try {
      const response = await fetch('/cart.json')
      const responseJson = await response.json();
      let itemsToRemove = [];
      responseJson.items.forEach((item) => {
        if (
          item.properties &&
          item.properties._remove_with &&
          item.properties._type_of_purchase
        ) {
          let removeWith = item.properties._remove_with;
          let typeOfPurchase = item.properties._type_of_purchase;
      
          let removeWithItems = responseJson.items.filter(
            (item) => item.product_id == removeWith
          );
      
          let matchingItems = removeWithItems.filter((removeWithItem) => {
            if (typeOfPurchase === 'one-time') {
              return !removeWithItem.selling_plan_allocation;
            } else if (typeOfPurchase === 'subscription') {
              return removeWithItem.selling_plan_allocation;
            } else if (typeOfPurchase === 'all') {
              return true;
            } else {
              // Invalid _type_of_purchase value
              // Handle the invalid case according to your requirements
              return false;
            }
          });

          if (!matchingItems || matchingItems.length === 0) {
            itemsToRemove.push(item.key);
          }
        } else if (cause === 'clearCart') {
          itemsToRemove.push(item.key);
        }
      });

      if(itemsToRemove.length > 0) {
          let updates = { updates: {} };
          for(let i = 0; i < itemsToRemove.length; i++) {
            updates.updates[itemsToRemove[i]] = 0;
          }
          await this.updateProducts(updates, 'remove');
      }
    } catch (error) {
      console.error('Error:', error);
    }
    
  }

  setInnerHTML(elm, html) {
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll("script")).forEach(
      (oldScriptEl) => {
        const newScriptEl = document.createElement("script");
        Array.from(oldScriptEl.attributes).forEach((attr) => {
          newScriptEl.setAttribute(attr.name, attr.value);
        });
        const scriptText = document.createTextNode(
          oldScriptEl.innerHTML
        );
        newScriptEl.appendChild(scriptText);
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
      }
    );
  }

  async updateFreeProductsSections(call) {
    //sections request
    const response = await fetch('/?sections=free-products');
    const responseJson = await response.json();
    let generalDOM =
      new DOMParser()
        .parseFromString(responseJson['free-products'], 'text/html')
        .querySelector('#free-products');
    let freeProductDOM;
    if(document.getElementById('free-products')) {
      freeProductDOM = document.getElementById('free-products');
    } else {
      freeProductDOM = document.createElement('div');
      freeProductDOM.id = 'free-products';
      freeProductDOM.classList.add('hidden');
      document.body.prepend(freeProductDOM);
    }
    this.setInnerHTML(freeProductDOM, generalDOM.innerHTML);
    try {
      const cartResponse = await fetch('/cart.json');
      const cartResponseJson = await cartResponse.json();
      if(window.cartAdditionsGlobal && Object.keys(window.cartAdditionsGlobal.items).length > 0) {
        await this.addProducts(window.cartAdditionsGlobal);
      }
      if(window.cartUpdatesGlobal && Object.keys(window.cartUpdatesGlobal.updates).length > 0) {
        await this.updateProducts(window.cartUpdatesGlobal, 'update');
      }
      if(window.stackedProductList && window.stackedProductList.length > 0) {
        await this.getDiscountedProducts(cartResponseJson);
      }
      if (!!window.addObjBySum || !!window.removeListBySum) {
        await this.updateProductsBySum(window.addObjBySum, window.removeListBySum);
      }
      if(window.mixAndMatch && this.isObjectEmpty(window.mixAndMatch) === false) {
        await this.handleMixAndMatch(cartResponseJson, window.mixAndMatch);
      }
      await FreeProducts.updateCartSections();
    } catch (error) {
      console.error('Error:', error);
    }
      
  }

  async updateProductsBySum(addObjBySum, removeListBySum) {
    const response = await fetch('/cart.json');
    const cart = await response.json();

    let updates = { updates: {} };

    if (removeListBySum && removeListBySum.length > 0) {
      const itemsToRemove = {};
      removeListBySum.forEach((item) => {
        const matchingItem = cart.items.find((cartItem) => {
          return cartItem.id == item && cartItem.properties && cartItem.properties.add_with_sum;
        });
        if (matchingItem) {
          itemsToRemove[matchingItem.id] = 0;
        }
      });
      Object.assign(updates.updates, itemsToRemove);
    }

    // Check if the cart.items contain matching variant_id and properties as the items in addObjBySum
    if (addObjBySum && Object.keys(addObjBySum).length > 0) {
      const itemsToUpdate = {};
      // Create a new array with items that should be kept
      addObjBySum.items = addObjBySum.items.filter((addObj) => {
          const matchingItem = cart.items.find((item) => {
              return item.variant_id === addObj.id && item.properties && item.properties.add_with_sum && item.quantity;
          });
          
          if (matchingItem) {
              itemsToUpdate[matchingItem.key] = addObj.quantity;
              return false; // Exclude this item from the new array
          }
          
          return true; // Keep this item in the new array
      });
      Object.assign(updates.updates, itemsToUpdate);
    }

    if (Object.keys(updates.updates).length > 0) {
      await this.updateProducts(updates, 'updateBySum');
    } else if(addObjBySum && Object.keys(addObjBySum).length > 0 && addObjBySum.items.length > 0) {
      await this.addProducts(addObjBySum);
    }

  }


  static async updateCartSections(openCartDrawer) {
    try {
      const response = await fetch('/cart.json');
      const responseJson = await response.json();
      const cartItems = document.querySelector('cart-items');
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if(!!cartItems) {
        const cartFooter = document.getElementById("main-cart-footer");
        // cartItems.classList.add('loading');
        // on cart page -- update cart items
        const responseCartItems = await fetch('/?sections=main-cart-items');
        const responseCartItemsJson = await responseCartItems.json();
        let mainCartItems =
          new DOMParser()
            .parseFromString(responseCartItemsJson['main-cart-items'], 'text/html')
            .querySelector('.js-contents').innerHTML;
        document.getElementById('main-cart-items').innerHTML = mainCartItems;
        // document.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        cartItems.classList.toggle("is-empty", responseJson.item_count === 0);
        if (cartFooter) {
          cartFooter.classList.toggle("is-empty", responseJson.item_count === 0);
        }
      } 

      // not on cart page -- update cart drawer
      else if(!!cartDrawerItems) {
        const responseCartDrawer = await fetch('/?sections=cart-drawer');
        const responseCartDrawerJson = await responseCartDrawer.json();
        let cartDrawerInner =
          new DOMParser()
            .parseFromString(responseCartDrawerJson['cart-drawer'], 'text/html')
            .querySelector('.drawer__inner').innerHTML;

        document.querySelector('.drawer__inner').innerHTML = cartDrawerInner;
        document.querySelector('cart-drawer').classList.toggle("is-empty", responseJson.item_count === 0);

        // update cart count in header
        const responseCartIconBubble = await fetch('/?sections=cart-icon-bubble');
        const responseCartIconBubbleJson = await responseCartIconBubble.json();
        const cartCountBubbleElement = document.querySelector('.cart-count-bubble');
        let cartCountBubble =
          new DOMParser()
          .parseFromString(responseCartIconBubbleJson['cart-icon-bubble'], 'text/html')
          .querySelector('.cart-count-bubble');
        if (cartCountBubbleElement) {
          if ( !!cartCountBubble ) {
            document.querySelector('.cart-count-bubble').innerHTML = cartCountBubble?.innerHTML;
          } else if ( cartCountBubbleElement ) {
            cartCountBubbleElement.innerHTML = '';
          }
          cartCountBubbleElement.classList.toggle("hidden", responseJson.item_count === 0);
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      const response = await fetch('/cart.json');
      const responseJson = await response.json();
      if(responseJson.items_subtotal_price == 0 && responseJson.item_count > 0) {
        await this.collectProductsToRemove('clearCart');
      } else {
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        if(openCartDrawer && !!cartDrawerItems) {
          document.querySelector('cart-drawer').open();
        }
      }
    }
  }

}

const freeProds = new FreeProducts();